import { createTypedSxStyles, capitalDesignTokens } from '@opengov/capital-mui-theme';

const muiV37Gray50 = '#F8F8F8';
const muiV37BlackOpacity12 = 'rgba(0, 0, 0, 0.12)';
export const styles = createTypedSxStyles({
  tableContainer: {
    border: `1px solid ${muiV37BlackOpacity12}`,
    borderRadius: '4px'
  },
  table: {
    overflow: 'auto',
    borderRadius: '4px'
  },
  headerCell: {
    textAlign: 'left',
    padding: '12px 16px',
    fontWeight: capitalDesignTokens.foundations.typography.fontWeight.semiBold,
    fontFamily: capitalDesignTokens.foundations.typography.baseFont,
    backgroundColor: muiV37Gray50,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '200px'
  },
  checkboxHeaderCell: {
    width: '48px',
    padding: '12px 16px',
    backgroundColor: muiV37Gray50
  },
  storyTitle: {
    fontWeight: capitalDesignTokens.foundations.typography.fontWeight.semiBold,
    color: 'inherit',
    display: 'block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    '&:visited': {
      color: 'inherit'
    }
  },
  bodyCell: {
    textAlign: 'left',
    padding: '12px 16px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '200px'
  },
  checkboxBodyCell: {
    width: '48px',
    padding: '12px 16px'
  },
  tableRow: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: capitalDesignTokens.foundations.colors.gray100
    }
  },
  tableRowDisabled: {
    cursor: 'default',
    opacity: 0.5
  },
  tableRowHighlighted: {
    animation: 'highlightFade 7s',
    '@keyframes highlightFade': {
      '0%': {
        border: `1px solid ${capitalDesignTokens.semanticColors.interaction.selectionLight}`,
        backgroundColor: `${capitalDesignTokens.semanticColors.interaction.hoverLight}`
      },
      '50%': {
        border: `1px solid ${capitalDesignTokens.semanticColors.interaction.selectionLight}`,
        backgroundColor: `${capitalDesignTokens.semanticColors.interaction.hoverLight}`
      },
      '100%': {
        border: `1px solid ${capitalDesignTokens.foundations.colors.gray300}`,
        backgroundColor: capitalDesignTokens.foundations.colors.white
      }
    }
  },
  emptyCell: {
    marginLeft: '8px'
  },
  publicationColumn: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    minWidth: '0',
    textOverflow: 'ellipsis',

    '& a': {
      color: capitalDesignTokens.foundations.colors.gray1000
    }
  },
  chip: {
    fontFamily: capitalDesignTokens.foundations.typography.baseFont,
    padding: '0px 6px'
  },
  paginationContainer: {
    borderTop: `1px solid ${muiV37BlackOpacity12}`
  }
});
